module.exports = __webpack_public_path__ + "img/erosion_grey_en.2785b068.svg";